"use strict";

exports.__esModule = true;
exports.DashboardThumbnail = DashboardThumbnail;
var _react = _interopRequireDefault(require("react"));
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _Widgets = require("../../Widgets");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Shows a thumbnail for a dashboard.
 */
function DashboardThumbnail(_ref) {
  var width = _ref.width,
    height = _ref.height,
    dashboard = _ref.dashboard;
  var widgets = _react["default"].useContext(_Widgets.WidgetsContext);
  return /*#__PURE__*/_react["default"].createElement(_ConfigurableLayout.LayoutThumbnail, {
    widgets: widgets.dashboardWidgets,
    config: dashboard,
    width: width,
    height: height
  });
}